import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCodeInsert: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="code-insert"><path d="M13.25 4.75H2.75V19.25H13.25M16.2454 4.75H21.2454V19.25H16.2454M16.2454 4.75V2.75M16.2454 4.75V19.25M16.2454 19.25V21.25M8.5 9.5L11 12L8.5 14.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCodeInsert;
